export const FLOATING_COUPON_LOGIN_SITUATION = '浮窗领券';
export const DEFAULT_LOGIN_SITUATION = '其他';

interface ResolveLoginSituationOptions {
  loginSituation?: string;
  isFloatingCouponEntry?: boolean;
}

export function resolveLoginSituation(options: ResolveLoginSituationOptions): string {
  const { loginSituation, isFloatingCouponEntry = false } = options;
  const normalized = typeof loginSituation === 'string' ? loginSituation.trim() : '';
  if (isFloatingCouponEntry && (!normalized || normalized === DEFAULT_LOGIN_SITUATION)) {
    return FLOATING_COUPON_LOGIN_SITUATION;
  }
  return normalized || DEFAULT_LOGIN_SITUATION;
}
